import { RoleId } from "../../user"
import { UserPermissions } from "../types"
import { ApiUserPermissions } from "./api"

/** @internal */
export interface ClimatePermissions {

    // Global read permission, also enables access to the module
    readonly read: boolean

    // Global write permission
    readonly write: boolean

    // Display the chill units chart
    readonly chillUnits?: boolean,

    // Crop growth permissions
    readonly cropGrowth: {
        // Global permission to use this component
        readonly enabled: boolean
        // Allow access to "development" crops
        // (Those are crops for which the growth profile have not been validated yet)
        readonly dev: boolean
    }

    // Risk models permissions
    readonly risks: {

        // Global permission to use this component
        readonly enabled: boolean

        // BYDV
        readonly bydv?: boolean

        // Potato blight
        readonly potatoBlight?: boolean

        // Frost risks
        readonly frost?: boolean

        // Hops downly mildew
        readonly hdm?: boolean

        // Ascospore and conidia spore scab
        readonly scab?: boolean

        // Spotted winged drosophila
        readonly swd?: boolean

        // Codling moth
        readonly codlingMoth?: boolean

        // Blackcurrant gall mite
        readonly blackcurrantGallMite?: boolean

        // Winter wheat diseases
        readonly wheatDiseases?: boolean

        // Winter barley diseases
        readonly barleyDiseases?: boolean

        // Winter wheat lodging
        readonly wheatLodging?: boolean

    }

}

export function getClimatePermissions(role: RoleId, clm: ApiUserPermissions["Climate"]): UserPermissions["climate"] {

    const admin = (role <= RoleId.Admin)
    const access = role == RoleId.Access

    clm = clm || {
        Enabled: admin || access,
        CropGrowth: admin,
        CropGrowthDev: admin,
        BYDV: admin,
        PotatoBlight: admin,
        Frost: admin,
        ChillUnits: admin,
        HDM: admin,
        Scab: admin,
        SWD: admin,
        CodlingMoth: admin,
        WheatDiseases: admin,
        BarleyDiseases: admin,
        WheatLodging: admin
    }

    const enabled = clm.Enabled || access

    return {

        read: enabled,
        write: enabled,

        chillUnits: clm.ChillUnits,

        cropGrowth: {
            enabled: clm.CropGrowth || false,
            dev: clm.CropGrowthDev || false
        },

        risks: {
            enabled: (clm.BYDV || clm.PotatoBlight || clm.Frost || clm.HDM || clm.Scab || clm.SWD || clm.CodlingMoth || clm.BlackcurrantGallMite || clm.WheatDiseases || clm.BarleyDiseases || clm.WheatLodging),
            bydv: clm.BYDV,
            potatoBlight: clm.PotatoBlight,
            frost: clm.Frost,
            hdm: clm.HDM,
            scab: clm.Scab,
            swd: clm.SWD,
            codlingMoth: clm.CodlingMoth,
            blackcurrantGallMite: clm.BlackcurrantGallMite,
            wheatDiseases: clm.WheatDiseases,
            barleyDiseases: clm.BarleyDiseases,
            wheatLodging: clm.WheatLodging
        }

    }

}
